import type { FullNameSplitModel } from "api";
import { fullName } from "helpers/user";
import React, { FC } from "react";

export interface WaybillGeneralInfoProps {
    carLogist?: FullNameSplitModel | null;
}

export const WaybillGeneralInfo: FC<WaybillGeneralInfoProps> = ({ carLogist }) => {
    const logistName = (carLogist && fullName(carLogist)) || "Не назначен";
    return (
        <section className="card mb-4">
            <div className="card-header py-2 font-weight-bold">Общая информация</div>
            <div className="card-body">
                <div>Логист ТС: {logistName}</div>
            </div>
        </section>
    );
};
